import { render } from "./app-header-message.vue?vue&type=template&id=17ebc9cb"
import script from "./app-header-message.vue?vue&type=script&lang=js"
export * from "./app-header-message.vue?vue&type=script&lang=js"

import "./app-header-message.vue?vue&type=style&index=0&id=17ebc9cb&lang=less"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__